import APIService from '@/services/APIService.js';

export default {
  getPredicoes(includeExpiredRecords) {
    return APIService.apiCall().get(`/predicoesBaixas/getPredicoesBaixas/${includeExpiredRecords}`);
  },
  getPredicao(id) {
    return APIService.apiCall().get(`/predicoesBaixas/getPredicao/${id}`);
  },
  getByStatus(status, filtroBase = null, filtroDataBase = null, filtroCenarioVinculado = null) {
    status = status.toUpperCase();
    const params = {
      base: filtroBase ?? undefined,
      data_base: filtroDataBase ?? undefined,
      cenario_vinculado: filtroCenarioVinculado ?? undefined
    };
    const queryParams = new URLSearchParams(params);
    const queryString = queryParams.toString();
    const query = queryString
      ? `/predicoesBaixas/get-by-status/${status}?${queryString}`
      : `/predicoesBaixas/get-by-status/${status}`;

    return APIService.apiCall().get(query);
  },
  postPredicao(dataPredicao, id = null) {
    const postData = { ...dataPredicao };
    return APIService.apiCall().post(`/predicoesBaixas/edit/${id}`, JSON.stringify(postData));
  },
  getCenario(id, idBtg, faixa, variavel) {
    return APIService.apiCall().get(`/predicoesBaixas/get_cenario/${id}/${idBtg}/${faixa}/${variavel}`, {
      ...{ timeout: 60 * 60 * 1000 }
    });
  },
  getCenariosProcessados(id) {
    return APIService.apiCall().get(`/predicoesBaixas/get_cenarios_processados/${id}`);
  },
  getDadosCenario(id) {
    return APIService.apiCall().get(`/predicoesBaixas/get_dados_cenario/${id}`);
  },
  downloadCenario(id, idBtg, cenarioEscolhido, postData, config = {}) {
    return APIService.apiCall().post(
      `/predicoesBaixas/download_cenario/${id}/${idBtg}/${cenarioEscolhido}`,
      JSON.stringify(postData),
      {
        responseType: 'blob',
        ...config
      }
    );
  },
  getPredicaoBoxPlot(id, variavel) {
    return APIService.apiCall().get(`/predicoesBaixas/getPredicaoBoxPlot/${id}/${variavel}`);
  },
  getTucagemLista(id) {
    return APIService.apiCall().get(`/predicoesBaixas/getTucagemLista/${id}`);
  },
  getPredicaoHistograma(id, idBtg, variavel) {
    return APIService.apiCall().get(`/predicoesBaixas/getPredicaoHistograma/${id}/${idBtg}/${variavel}`);
  },
  executarPredicao(id) {
    return APIService.apiCall().get(`/predicoesBaixas/executar/${id}`);
  },
  deletePredicao(id) {
    return APIService.apiCall().get(`/predicoesBaixas/delete/${id}`);
  },
  setarCenarioVinculado(id, cenario) {
    return APIService.apiCall().post(`/predicoesBaixas/setarCenarioVinculado/${id}`, JSON.stringify(cenario));
  },
  downloadLogs(postData) {
    return APIService.apiCall().post('/predicoesBaixas/downloadLogs/', JSON.stringify(postData), {
      responseType: 'blob',
      ...{ timeout: 60 * 60 * 1000 }
    });
  }
};
